import { Navigate, useParams } from "react-router";
import { useUserByIdQuery,useUpdateUserMutation } from "../../stores/OkOkStore";
import UserManagers from "../../components/Users/UserManagers";
import type { RefUser } from "../../types/Users";
import { useEffect, useState } from "react";
import { useTrads } from "../../contexts/trads/useTrads";
function UserManager(){
    const params = useParams();
    const { data, error, isLoading } = useUserByIdQuery(params.userId??"0");

    const [updateUser,result]=useUpdateUserMutation();
    const [managers,setManagers]=useState<number[]>(data?.managers?? []);


    const saveUser=function(){
        if(data){
            const x:RefUser={id:data.id,managers:managers};
            void updateUser(x);
        }
    }
    const {translate}=useTrads();

    useEffect(()=>{
        if(data?.managers){
            setManagers(data.managers);
        }
    },[data,setManagers]);



        return (
        result.isSuccess ? <Navigate to={`/user/${result.data.id.toString()}`} state={{modified:"true"}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_error_save_user')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
            error ? (
                    <p className="p-3 mb-2 bg-danger text-white">{translate('page_error_save_user')}</p>
            ) : isLoading ? (
                     <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> 
            ) : data ? (
                <div>
                    <UserManagers managers={managers} clickHandler={setManagers} />
                    <button onClick={saveUser}>{translate('btn_save')}</button>
                </div>
            ):null
        )
        );
}
export default UserManager;